export enum RouteConstants {
  LandingPage = "landing",
  Logout = "logout",
  PageNotFound = "page-not-found",
  Chatbot = "chatbot",
  ImageGeneration = "image-generation",
  Summary = "summary",
  Transcription = "transcription",
  Translation = "translation",
  ContentManagement = "contentManagement",
  RejectedTermsOfUse = "rejected-terms-of-use",
  AdminArea = "admin-area",
  UserSettingsArea = "user-settings-area",
  Ai = "ai",
}
